import { useTranslation } from 'react-i18next';

import { ToursSearchForm } from '@frontend/features/travel-services/components/ToursSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de experiencias (vertical tours de Rutero). */
export const Experiences = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.experiences')}
      intro={t('travelServices.experiencesIntro')}
    >
      <ToursSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Experiences;
